import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const baremaRoutes: Routes = [
  {
    path: 'barema',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Parametrizar Barema',
      breadcrumb: [{ label: 'Barema' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./barema.component').then((m) => m.BaremaComponent),
        data: {
          title: 'Consulta Versões do Barema',
          roles: [Role.BAREMA_CONSULTAR],
          breadcrumb: [{ label: 'Baremas', url: '/barema' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./barema-form/barema-form.component').then(
            (m) => m.BaremaFormComponent,
          ),
        data: {
          title: 'Cadastrar Barema',
          roles: [Role.BAREMA_CADASTRAR],
          breadcrumb: [
            { label: 'Baremas', url: '/barema' },
            { label: 'Cadastrar', url: '/barema/cadastrar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./barema-visualizar/barema-visualizar.component').then(
            (m) => m.BaremaVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Barema',
          roles: [Role.BAREMA_CONSULTAR],
          breadcrumb: [
            { label: 'Baremas', url: '/barema' },
            { label: 'Visualizar', url: '/barema/visualizar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./barema-form/barema-form.component').then(
            (m) => m.BaremaFormComponent,
          ),
        data: {
          title: 'Editar Barema',
          roles: [Role.BAREMA_EDITAR],
          breadcrumb: [
            { label: 'Baremas', url: '/barema' },
            { label: 'Editar', url: '/barema/editar' },
          ],
        },
      },
      {
        path: 'itens/:id',
        loadComponent: () =>
          import('./itens/item-barema.component').then(
            (m) => m.ItemBaremaComponent,
          ),
        data: {
          title: 'Itens de Barema',
          roles: [
            Role.BAREMA_CONSULTAR,
            Role.BAREMA_EDITAR,
            Role.BAREMA_CADASTRAR,
          ],
          breadcrumb: [
            { label: 'Baremas', url: '/barema' },
            { label: 'Itens', url: '/barema/itens' },
          ],
        },
      },
      {
        path: 'itens',
        children: [
          {
            path: 'cadastrar',
            loadComponent: () =>
              import('./itens/item-barema-form/item-barema-form.component').then(
                (m) => m.ItemBaremaFormComponent,
              ),
            data: {
              title: 'Cadastrar Item de Barema',
              roles: [Role.BAREMA_CADASTRAR, Role.BAREMA_EDITAR],
              breadcrumb: [
                { label: 'Baremas', url: '/barema' },
                { label: 'Itens', url: '/barema/itens' },
                { label: 'Cadastrar', url: '/barema/itens/cadastrar' },
              ],
            },
          },
          {
            path: 'editar/:id',
            loadComponent: () =>
              import('./itens/item-barema-form/item-barema-form.component').then(
                (m) => m.ItemBaremaFormComponent,
              ),
            data: {
              title: 'Editar Item de Barema',
              roles: [Role.BAREMA_EDITAR],
              breadcrumb: [
                { label: 'Baremas', url: '/barema' },
                { label: 'Itens', url: '/barema/itens' },
                { label: 'Editar', url: '/barema/itens/editar' },
              ],
            },
          },
        ],
      },
      {
        path: 'categorias',
        loadComponent: () =>
          import('./categorias/categoria-barema.component').then(
            (m) => m.CategoriaBaremaComponent,
          ),
        data: {
          title: 'Lista de Categorias do Barema',
          roles: [
            Role.CATEGORIA_CADASTRAR,
            Role.BAREMA_CONSULTAR,
            Role.BAREMA_EDITAR,
          ],
          breadcrumb: [
            { label: 'Baremas', url: '/barema' },
            { label: 'Categorias', url: '/barema/categorias' },
          ],
        },
      },
      {
        path: 'grupos',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./grupos/grupo-barema.component').then(
                (m) => m.GrupoBaremaComponent,
              ),
            data: {
              title: 'Grupos de Barema',
              roles: [Role.BAREMA_CONSULTAR, Role.BAREMA_EDITAR],
              breadcrumb: [
                { label: 'Baremas', url: '/barema' },
                { label: 'Grupos', url: '/barema/grupos' },
              ],
            },
          },
          {
            path: 'cadastrar',
            loadComponent: () =>
              import('./grupos/grupo-barema-form/grupo-barema-form.component').then(
                (m) => m.GrupoBaremaFormComponent,
              ),
            data: {
              title: 'Cadastrar Grupo de Barema',
              roles: [Role.BAREMA_CADASTRAR, Role.BAREMA_EDITAR],
              breadcrumb: [
                { label: 'Baremas', url: '/barema' },
                { label: 'Grupos', url: '/barema/grupos' },
                { label: 'Cadastrar', url: '/barema/grupos/cadastrar' },
              ],
            },
          },
          {
            path: 'editar/:id',
            loadComponent: () =>
              import('./grupos/grupo-barema-form/grupo-barema-form.component').then(
                (m) => m.GrupoBaremaFormComponent,
              ),
            data: {
              title: 'Editar Grupo de Barema',
              roles: [Role.BAREMA_EDITAR],
              breadcrumb: [
                { label: 'Baremas', url: '/barema' },
                { label: 'Grupos', url: '/barema/grupos' },
                { label: 'Editar', url: '/barema/grupos/editar' },
              ],
            },
          },
        ],
      },
      {
        path: 'tipos-item',
        loadComponent: () =>
          import('./tipos-item/tipos-item-barema.component').then(
            (m) => m.TiposItemBaremaComponent,
          ),
        data: {
          title: 'Lista de Itens',
          roles: [Role.BAREMA_CONSULTAR, Role.BAREMA_EDITAR],
          breadcrumb: [
            { label: 'Baremas', url: '/barema' },
            { label: 'Tipos de Item', url: '/barema/tipos-item' },
          ],
        },
      },
    ],
  },
];
